import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { Mail } from '../icons';

const HIDDEN_PATHS = new Set([
    '/login', '/register', '/addtrip', '/adddelivery',
    '/mytrips', '/profil', '/mydeliveries', '/searchannouncements',
    '/announcements', '/messages', '/demandresetpassword',
]);

function Footer() {
    const path  = window.location.pathname;
    const first = path.split('/')[1];

    if (
        HIDDEN_PATHS.has(path) ||
        first === 'userprofile' || first === 'mytrips' ||
        first === 'mydeliveries' || first === 'announcements' || first === 'messages'
    ) return <div></div>;

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-6 col-lg-4 mb-4">
                        <Link to="/home" className="footer-brand">eudeliv</Link>
                        <p className="footer-tagline">
                            La plateforme de transport de colis entre particuliers. Simple, économique et solidaire.
                        </p>
                        <div className="footer-social">
                            <a href="https://www.instagram.com/eudeliv/" target="_blank" rel="noopener noreferrer" title="Instagram">
                                <FaInstagram size={16} />
                            </a>
                            <a href="https://www.facebook.com/eudeliv-103571514714472/" target="_blank" rel="noopener noreferrer" title="Facebook">
                                <FaFacebook size={16} />
                            </a>
                            <a href="https://www.linkedin.com/company/eudeliv/?viewAsMember=true" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                <FaLinkedinIn size={16} />
                            </a>
                            <a href="https://www.youtube.com/watch?v=t6bhZzGZ7kg&t" target="_blank" rel="noopener noreferrer" title="YouTube">
                                <FaYoutube size={16} />
                            </a>
                            <a href="mailto:contact@eudeliv.com" title="Email">
                                <Mail size={16} />
                            </a>
                        </div>
                    </div>

                    <div className="col-6 col-sm-3 col-lg-2 mb-4 offset-lg-1">
                        <h6 className="footer-heading">Services</h6>
                        <Link to="/adddelivery"      className="footer-link">Envoyer un colis</Link>
                        <Link to="/addtrip"          className="footer-link">Transporter un colis</Link>
                        <Link to="/searchannouncements" className="footer-link">Rechercher</Link>
                        <Link to="/register"         className="footer-link">Créer un compte</Link>
                    </div>

                    <div className="col-6 col-sm-3 col-lg-2 mb-4">
                        <h6 className="footer-heading">À propos</h6>
                        <Link to="/history"            className="footer-link">Notre histoire</Link>
                        <Link to="/howitworks"         className="footer-link">Comment ça marche</Link>
                        <Link to="/contact"            className="footer-link">Contact</Link>
                        <Link to="/conditionutilisation" className="footer-link">Conditions d'utilisation</Link>
                    </div>

                    <div className="col-6 col-sm-3 col-lg-2 mb-4">
                        <h6 className="footer-heading">Blog</h6>
                        <Link to="/blog" className="footer-link">Guide d'envoi</Link>
                        <Link to="/blog" className="footer-link">Pourquoi eudeliv ?</Link>
                        <Link to="/blog" className="footer-link">Guide voyageur</Link>
                        <Link to="/blog" className="footer-link">Tous les articles</Link>
                    </div>
                </div>

                <hr className="footer-divider" />

                <div className="row align-items-center">
                    <div className="col-12 col-md-6 mb-2 mb-md-0">
                        <span className="footer-bottom-text">© {new Date().getFullYear()} eudeliv — Tous droits réservés</span>
                    </div>
                    <div className="col-12 col-md-6 text-md-right">
                        <Link to="/conditionutilisation" className="footer-link d-inline mr-3" style={{ fontSize: '0.78rem' }}>Conditions</Link>
                        <Link to="/contact"              className="footer-link d-inline"     style={{ fontSize: '0.78rem' }}>Contact</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
